import { Boundaries } from "@planzone/core";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State } from "./types";

function handleFailure(
  state: State,
  project: Boundaries["retrieveDiscussions"]["failure"],
): State {
  return state.map((result) =>
    result.project.uuid === project.uuid
      ? { ...result, request: setRequestStateToFailure() }
      : result,
  );
}

export { handleFailure };
